<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr">
          <div class="guideMsg">
            <p class="txtL">
              상담신청을 남겨주시면
              <br />
              웰몰 전문상담원이 상담해 드립니다.
            </p>
          </div>

          <div class="formArea">
            <span class="label">
              이름
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="userName" />

            <span class="label">
              휴대폰번호
              <span class="required"><span class="blind">필수</span></span>
            </span>
            <input
              type="tel"
              id="phone_2"
              class="ipt"
              title="휴대폰 번호 입력"
              placeholder="' - ' 없이 입력해주세요."
              value=""
              v-model="cellNum"
              v-onlyNum
            />

            <!-- 약관 (s) -->
            <div class="termsWrap">
              <div class="inner">
                <ul class="iptGroup">
                  <li>
                    <div class="block">
                      <input type="checkbox" class="ipt" name="terms1" id="terms1_3" v-model="terms" />
                      <label for="terms1_3">
                        <span>[필수]</span>
                        개인정보수집 및 이용약관 동의
                      </label>
                      <button type="button" class="links arrow" @click="popupOpen"><span class="blind">상세약관 전체보기</span></button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 약관 (e) -->
          </div>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="requestConsult" :disabled="regButtonShow">상담예약</button>
          </div>
        </section>
        <MessagePop v-if="messagePopFlag" @close="close">
          <p v-html="msg"></p>
        </MessagePop>
        <CallServiceTermPop v-if="CallServiceTermPopFlag" @close="close" @agree="agree"></CallServiceTermPop>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import JwtService from '@/common/jwt.service';
import { PDP_RESERVATION_ADVICE, INPUT_INFO_CHECK, TERM_AGREE_CHECK, SERVICE_COMM_ERROR } from '@/store/message.type.js';
import CallServiceTermPop from '@/views/app/comm/CallServiceTermPop';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'ProductRequestConsult',
  components: { MessagePop, CallServiceTermPop },
  data() {
    return {
      headerTitle: '전화상담신청',

      cellNum: null,
      userName: null,
      terms: null,

      messagePopFlag: null,
      msg: null,
      CallServiceTermPopFlag: null,
      orderType: null,
      productCode: null,
      internalProdCode: null,
      userId: '',
      passValidate: false,
      marParam: '', //마케팅정보

      regButtonShow: true,
    };
  },
  watch: {
    userName() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
    terms() {
      this.checkInput();
    },
  },
  mounted() {
    console.log(JwtService.getMarParam());
    if (JwtService.getUserInfo()) {
      this.userId = JwtService.getUserInfo().userId;
      this.userName = JwtService.getUserInfo().userName;
      this.cellNum = JwtService.getUserInfo().mobile;
    }

    if (this.$route.params.orderType == 'rental') {
      this.orderType = 'RORT00GE';
    } else {
      this.orderType = 'RORT00SE';
    }
    
    this.productCode = this.$route.params.productCode;
    this.internalProdCode = this.$route.params.internalProdCode;
    
  },
  methods: {
    requestConsult() {
      this.passValidate = true;
      if (!this.terms) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.cellNum == null || this.cellNum == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.userName == null || this.userName == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.passValidate) {
        let param = new Object();
        let request = new Object();


        // ?g=1234&echo_key=5678
        // echo/g_code is not null
        // 0 index : echo_key
        // 1 index : g_code
        if(JwtService.getMarParam() && JwtService.getMarParam != null){
          request.marParam = JwtService.getMarParam();
        }
        request.cellNum = this.cellNum;
        request.internalProdCode = this.internalProdCode;
        request.orderName = this.userName;
        request.saleType = this.orderType;
        request.userId = this.userId;
        request.sellerEmp = 'WM_APP'; 

        param.request = request;
        param.serviceType = 'app';

        ApiService.service('POST', '/order/regist/simple', param)
          .then(({ data }) => {
            console.log('data:::::', data);
            if (data.isSucceed) {
              this.msg = PDP_RESERVATION_ADVICE;
              this.messagePopFlag = true;
              const params = {
                af_content_id: this.productCode,
              };

              window.appsFlyer('af_complete_reservation', params);

              //this.$router.go(-1);
            } else {
              this.passValidate = false;
              //this.msg = SERVICE_COMM_ERROR;
              this.msg = '단종된 상품입니다.';
              this.messagePopFlag = true;
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    requestConsultOk() {
      this.messagePopFlag = false;
      this.CallServiceTermPopFlag = false;

      this.$router.go(-1);
    },
    close() {
      this.messagePopFlag = false;
      this.CallServiceTermPopFlag = false;
      if (this.passValidate) {
        this.$router.go(-1);
      }
    },
    agree() {
      this.terms = true;
      this.CallServiceTermPopFlag = false;
    },
    popupOpen() {
      this.CallServiceTermPopFlag = true;
    },
    checkInput() {
      if (!isEmpty(this.userName) && !isEmpty(this.cellNum) && this.terms === true) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
